import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-black text-white border-t-8 border-yellow-400" data-id="element-57">
      <div className="max-w-3xl mx-auto text-center" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-59">
          <ShieldCheckIcon className="w-24 h-24 text-yellow-400 mx-auto mb-6" data-id="element-60" />

          <h2 className="text-4xl md:text-5xl font-black text-white mb-8 uppercase tracking-wide" data-id="element-61">
            🔒 GARANTÍA TOTAL DE 7 DÍAS
          </h2>

          <div className="text-xl md:text-2xl text-gray-300 space-y-4 mb-12 max-w-2xl mx-auto font-medium" data-id="element-62">
            <p data-id="element-63">Probalo durante 7 días completos con tus hijos.</p>
            <p data-id="element-64">
              Si sentís que no es para tu familia, te devolvemos el 100% del
              dinero.
            </p>
            <p className="text-yellow-400 font-bold" data-id="element-65">
              Sin preguntas. Sin letra chica. Sin riesgo para vos.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-800 p-8 rounded-2xl mb-12 shadow-2xl" data-id="element-66">
            <h3 className="text-3xl font-black text-red-500 mb-4" data-id="element-67">
              ❤️ La infancia de tus hijos no se pausa
            </h3>
            <p className="text-2xl font-bold text-white mb-2" data-id="element-68">
              No necesitás más tiempo. Necesitás mejores momentos.
            </p>
            <p className="text-2xl font-bold text-yellow-400 mb-4" data-id="element-69">
              Y hoy podés empezar a crearlos.
            </p>
            <p className="text-lg text-gray-400 font-medium" data-id="element-70">
              Dentro de unos años, tus hijos no van a recordar qué había en la
              tele. Van a recordar lo que hicieron con vos.
            </p>
          </div>

          <div className="max-w-md mx-auto" data-id="element-71">
            <CTAButton text="👉 QUIERO CREAR RECUERDOS HOY" size="sm" data-id="element-72" />
          </div>
        </motion.div>
      </div>
    </section>;
}